module.exports = __webpack_public_path__ + "static/team-33-9f08702b5b5c7e7d12714002f3b73cbb.jpg";